"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processItinerary = void 0;
const factories_1 = require("../../factories");
const helpers_1 = require("../../helpers");
const dayjs = require("dayjs");
const itinerary_1 = require("../itinerary");
const __1 = require("..");
const invokeapi_1 = require("../invokeapi");
const processItinerary = async (supabase, data, available_region_courses, current_user, default_status = helpers_1.OrderStatus.UNSAVED, source = "GolfB2B", order_id, variant_id, onSuccess) => {
    const order = null;
    let order_obj = order;
    let variant_obj = null;
    if (!order) {
        if (order_id && variant_id) {
            const response = await factories_1.OrderRequestFactory.getOrderById(supabase, order_id);
            order_obj = response;
            variant_obj = variant_id;
        }
        else if (order_id && !variant_id) {
            const response = await factories_1.OrderRequestFactory.getOrderById(supabase, order_id);
            order_obj = response;
            const new_variant_name = `Variant ${String.fromCharCode(65 + response?.variants?.length || 0)}`;
            // create a new variant
            const new_variant = await factories_1.OrderRequestFactory.createVariant(supabase, order_id, new_variant_name);
            variant_obj = new_variant?.id;
        }
        else {
            const defaultExpiry = dayjs().add(14, "days");
            const tripStart = data?.trip?.start_date
                ? dayjs(data.trip.start_date)
                : null;
            let computedExpiry = defaultExpiry;
            if (tripStart && tripStart.isBefore(defaultExpiry)) {
                const twoDaysBeforeTravel = tripStart.subtract(2, "days");
                computedExpiry = twoDaysBeforeTravel.isAfter(dayjs())
                    ? twoDaysBeforeTravel
                    : dayjs();
            }
            const new_obj = {
                source: source,
                method: "Web",
                client_id: current_user.id,
                mode: "MANUAL",
                display_currency: current_user?.display_currency,
                status: default_status,
                agent_id: current_user?.agent.id,
                expiry_date: computedExpiry.toISOString(),
                assigned_to: current_user?.agent?.default_assigned_to || null,
            };
            const { data: createdOrder } = await factories_1.OrderRequestFactory.createOrder(supabase, new_obj);
            order_obj = createdOrder;
            variant_obj = order_obj.default_variant_id;
        }
    }
    if (order_obj) {
        if (data?.courses?.itinerary.length === 0) {
            return;
        }
        await (0, itinerary_1.CreateItinerary)({
            itinerary: data,
            order: order_obj,
            courses: available_region_courses,
            variant_id: variant_obj,
            supabase,
        });
        // get the variant that has just been created
        const new_variant = await factories_1.OrderRequestFactory.getVariantById(supabase, variant_obj);
        // set variant settings
        if (new_variant) {
            // Ensure config exists, if not create an empty object
            const config = new_variant.config || {};
            // Initialize legs array if it doesn't exist
            if (!Object.prototype.hasOwnProperty.call(config, "legs")) {
                config.legs = [];
            }
            const golf_data = data.courses.itinerary?.map((x) => {
                if (!x?.config)
                    return null;
                return {
                    id: x.config.course.id,
                    name: x?.config?.course?.name?.en,
                };
            });
            // Add new leg
            config.legs = [
                ...config.legs,
                {
                    trip: data.trip,
                    transfer: data.transfers,
                    golf: golf_data,
                    hotel: {
                        id: data?.hotel?.where_when_who?.hotel?.id,
                        name: data?.hotel?.where_when_who?.hotel?.name?.en,
                        transfer_area: data?.hotel?.where_when_who?.hotel?.transfer_area,
                    },
                },
            ];
            await factories_1.OrderRequestFactory.updateVariantConfig(supabase, variant_obj, config);
        }
        if (new_variant &&
            (0, __1.variantHasActionRequired)(new_variant) &&
            order_obj?.status !== "UNSAVED" &&
            source === "GolfB2B") {
            await (0, invokeapi_1.invokeapi)("b2b/golfb2bActionRequiredNotification", {
                method: "POST",
                body: {
                    order_id: order_obj.id,
                    variant_id: variant_obj,
                },
            });
        }
        onSuccess &&
            (await onSuccess({
                order_id: order_obj.id,
                variant_id: variant_obj,
            }));
    }
};
exports.processItinerary = processItinerary;
